import { connect } from 'react-redux';
import { phoneSelector } from 'store/selectors/app';

export default connect(phoneSelector);
